import { type PropsWithChildren } from "react";
import { cn } from "../lib/utils";
import { Spinner } from "./Spinner";

export const LoadingWrapper = ({
  isLoading = false,
  className,
  overlayClassName,
  children,
}: PropsWithChildren & { className?: string; overlayClassName?: string; isLoading?: boolean }) => {
  return (
    <div className={cn(className, "relative")}>
      {isLoading && (
        <div
          className={cn(
            "absolute inset-0 z-10 flex items-center justify-center overflow-hidden text-center backdrop-blur-[2px]",
            overlayClassName,
          )}
        >
          <Spinner className="mx-auto" />
        </div>
      )}
      {children}
    </div>
  );
};
